import type { FC } from "react"
import { useEffect, useMemo } from "react"
import Stories from "react-insta-stories"
import type { WithStoriesFragment } from "~/contentful"
import { createPortal } from "react-dom"
// import ChevronUp from "~/icons/ChevronUp"
import video from "~/components/capsules/stories/VideoRenderer"
import useWindowSize from "~/hooks/useWindowSize"
import Close from "~/icons/Close"
import type { Story } from "react-insta-stories/dist/interfaces"
// import ChevronUp from "~/icons/ChevronUp"

interface Props {
  thumbnail?: string | null | undefined
  itemsCollection?: WithStoriesFragment["itemsCollection"]
  title?: string | null | undefined
  hasNext?: boolean
  index?: number
  currentItem?: number
  onThumbnailClick?: () => void
  onStoryEnd?: () => void
  onPrevious?: () => void
  onNext?: () => void
  open?: boolean
  onClose: () => void
}

const CampStories: FC<Props> = props => {
  const stories: Story[] = useMemo(
    () =>
      props.itemsCollection?.items.length
        ? props.itemsCollection?.items.map(item => {
            if (item?.__typename === "CapsuleImage") {
              return {
                url: item.image?.url ?? "",
                type: "image"

                // seeMore: ({ close }: { close: () => void }) => {
                //   return (
                //     <div className="fixed bottom-10 left-1/2 -translate-x-1/2">
                //       <Button size="large" onClick={close} style="inverted">
                //         Click Me!
                //       </Button>
                //     </div>
                //   )
                // },
                // seeMoreCollapsed: customCollapsedComponent
              }
            } else if (item?.__typename === "CapsuleVideo") {
              return {
                url: `https://stream.mux.com/${item.file.playbackId}.m3u8`,
                type: "video"
                // seeMore: ({ close }: { close: () => void }) => {
                //   return (
                //     <div className="fixed bottom-10 left-1/2 -translate-x-1/2">
                //       <Button size="large" onClick={close} style="inverted">
                //         Click Me!
                //       </Button>
                //     </div>
                //   )
                // },
                // seeMoreCollapsed: customCollapsedComponent
              }
            } else {
              return {}
            }
          })
        : [],
    [props.itemsCollection?.items]
  )

  const thumbnail = props.thumbnail
    ? props.thumbnail
    : props.itemsCollection?.items[0]?.__typename === "CapsuleImage"
      ? props.itemsCollection?.items[0]?.image?.url
      : props.itemsCollection?.items[0]?.__typename === "CapsuleVideo"
        ? props.itemsCollection?.items[0]?.overlay?.url
        : undefined

  const windowSize = useWindowSize()

  useEffect(() => {
    if (props.open) {
      document.body.style.overflow = "hidden"
    } else {
      document.body.style.overflow = "auto"
    }
  }, [props.open])

  if (!stories.length) return null

  if (!props.open) {
    return (
      <div className="my-4 flex flex-col items-center justify-center md:hidden">
        <button
          className="relative mx-3 my-1 h-[78px] w-[78px] rounded-full border-2 border-teal-500"
          onClick={props.onThumbnailClick}
          aria-label="Open Camp Stories"
        >
          {props.index === 0 && (
            <div className="absolute left-[0.8rem] top-[0.8rem] m-auto h-[45px] w-[45px] animate-ping rounded-full border-2 border-teal-500" />
          )}
          {thumbnail ? (
            <img
              loading="lazy"
              src={thumbnail}
              alt="story thumbnail"
              className="m-auto h-[64px] w-[64px] rounded-full object-cover"
            ></img>
          ) : null}
        </button>
        {props.title && (
          <p className="w-28 text-center font-sans text-base text-camp-primary">
            {props.title}
          </p>
        )}
      </div>
    )
  } else {
    return createPortal(
      <div className="fixed left-0 top-0 z-60 md:hidden">
        <button
          onClick={props.onClose}
          title="Close"
          className="fixed right-5 top-7 z-max h-8 w-8 rounded-full bg-white"
        >
          <Close className="m-auto w-[10px] text-black" />
        </button>
        <Stories
          stories={stories}
          onPrevious={props.onPrevious}
          onNext={props.onNext}
          storyStyles={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            position: "fixed",
            top: "50%",
            left: 0,
            transform: "translateY(-50%)"
          }}
          height={windowSize.height}
          width={windowSize.width}
          onAllStoriesEnd={props.onStoryEnd}
          keyboardNavigation
          renderers={[video]}
          progressStyles={{ height: "0.4rem", borderRadius: "50px" }}
          progressWrapperStyles={{
            height: "0.4rem",
            borderRadius: "50px",
            overflow: "hidden",
            marginLeft: "3px",
            marginRight: "3px"
          }}
        />
      </div>,
      document.body
    )
  }
}

// const customCollapsedComponent = ({
//   toggleMore
// }: // action
// {
//   toggleMore: (show: boolean) => void
//   // action: Action
// }) => {
//   return (
//     <div
//       className="fixed bottom-10 left-1/2 -translate-x-1/2"
//       onClick={() => toggleMore(true)}
//       aria-hidden="true"
//     >
//       <ChevronUp className="mx-auto w-8 text-white" />
//       <h2 className="font-sans text-lg text-white">See More</h2>
//     </div>
//   )
// }

export default CampStories
